export default __webpack_public_path__ + "static/media/formosan-9.fb5ff0d3.jpg";